export default "__VITE_ASSET__D9K94eVQ__"